import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import { _t, capitalize } from 'utils';
import { getAssets } from 'themes/assets';
import { ROUTE, K8S_CLUSTER_STATE } from 'constant';
import { useSelector } from 'react-redux';
import useFilter from './hooks/filter';
import CreateForm from './create';

export default ({ history }) => {
  const [clusters, , FilterComponent] = useFilter();
  const assets = getAssets();
  const { listViewType = '' } = useSelector((e) => e);

  useEffect(() => {
    actions.kubernetes.cluster.getAll();
    actions.common.setLayoutTitle({ layout: { title: _t('Kubernetes'), menu: ROUTE.DASHBOARD.KUBERNETES.key } });
  }, []);

  return (
    <div style={{ margin: '15px 10px' }} className="screen-common">
      <Shared.widgets.Cards
        title={_t('Clusters')}
        type="common"
        filterRender={FilterComponent}
        addAction={ACTIONS_TYPES.KUBERNETES.CLUSTER.CREATE}
        addRender={<CreateForm />}
        isEmpty={!clusters.length}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              clusters.map((cluster) => {
                const {
                  properties, id, metadata = {},
                } = cluster;
                const { state = '' } = metadata;
                const {
                  name, k8sVersion,
                } = properties;

                return ([
                  <Shared.utilities.StatusLED state={state} />,
                  {
                    value: name,
                    link: id,
                  },
                  k8sVersion,
                ]);
              })
            }
            onCellClick={(id) => history.push(`/kubernetes/${id}`)}
            columns={[
              { name: '' },
              { name: 'Name' },
              { name: 'Version' },
            ]}
          />
        ) : (clusters.map((cluster) => {
          const {
            properties, id, metadata = {},
          } = cluster;
          const { state = '' } = metadata;
          const {
            name, k8sVersion,
          } = properties;

          return (
            <Shared.widgets.CardBasic
              iconFill="#326ce4"
              image={assets.KubernatesLogoWhite}
              title={name}
              details={(
                <div>
                  <span>
                    <Shared.utilities.StatusLED state={state} />
                    <span style={{ marginLeft: 3 }}>{capitalize(state)}</span>
                  </span>
                  <Shared.utilities.Separator />
                  {k8sVersion}
                </div>
              )}
              isLoader={state !== K8S_CLUSTER_STATE.ACTIVE}
              onClick={() => history.push(`/kubernetes/${id}`)}
              key={id}
            />
          );
        }))}
      </Shared.widgets.Cards>
    </div>
  );
};
